// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"e9b79a70","869":"80988200","956":"dc27fddb"}[chunkId] + ".chunk.js";
};